module.exports = "/_next/static/files/379063cb56a684a847276017bf7ff578.jpg";